/**
 * Controller: TemplatesCreateSchedulesRemoveModal
 */
angular.module('acme.view.application.templates.create.schedules.create.removeModal.controllers', [])
.controller('TemplatesCreateSchedulesRemoveModalController', [ '$scope', '$uibModalInstance', 'currentSchedule', 'SoldQuantity', 'emailSetting', function ($scope, $uibModalInstance, currentSchedule, SoldQuantity, emailSetting) {

    $scope.errors = [];

    $scope.model = {};

    $scope.notificationEmail = true;
    $scope.notificationType = 'always';
    $scope.notificationList = [];

    $scope.init = function() {
      this.model = currentSchedule;
      $scope.setNotificationList();

      $scope.notificationType = emailSetting;
    };

    $scope.setNotificationList = function() {
      angular.forEach(this.model.resourceRequests, function(item, index) {
        if (item.eventResource.resourceCategory === 'Personnel' && item.eventResource.hasOwnProperty('resourceName') && item.eventResource.resourceName.length) {
          $scope.notificationList.push(item.eventResource.resourceName);
        }
      });
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.hasSold = function() {
      return (SoldQuantity && SoldQuantity > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);